let uuid = 0;
export default {
    data() {
        uuid++
        return {
            rawUuid: `uid-${uuid}`
        }
    },
    methods: {
        uuid(val){
            return `${this.rawUuid}-${val}`
        }
    }
};